import { COLOR } from '@/shared/design-tokens/design-tokens';

/**
 * 일반 모니터링 메트릭 갱신 설정
 */
export const REFETCH_INTERVAL = 30000; // 30초 자동 갱신
export const STALE_TIME = 60000; // 1분 캐시 유지
export const RANGE_SECONDS = 3540;

/**
 * GPU 메트릭 쿼리 설정
 */
export const GPU_METRICS_CONFIG = {
  REFETCH_INTERVAL: 30 * 1000, // 30초
  STALE_TIME: 30 * 1000, // 30초
  RETRY_COUNT: 1,
  RANGE_SECONDS: 3600, // 1시간
  STEP_SECONDS: 30, // 30초 간격
} as const;

/**
 * GPU 차트 색상 팔레트
 */
export const GPU_CHART_COLORS = [COLOR.GREEN[50], COLOR.ORANGE[50], COLOR.BLUE[50], COLOR.RED[50]] as const;

export const BYTES_TO_KB = 1000;
export const BYTES_TO_MB = 1024 * 1024;
export const BYTES_TO_GB = 1024 * 1024 * 1024;

export const FIGMA_POD_SERIES_COLOR_SEQUENCE = [
  COLOR.FUCHSIA[70],
  COLOR.PURPLE[50],
  COLOR.INDIGO[60],
  COLOR.BLUE[70],
  COLOR.TURQUOISE[80],
  COLOR.EMERALD[80],
  COLOR.OLIVE[100],
  COLOR.CHARTREUSE[100],
  COLOR.YELLOW[100],
  COLOR.ORANGE[100],
  COLOR.GREEN[100],
  COLOR.MAGENTA[100],
  COLOR.RED[100],
  COLOR.FUCHSIA[94],
  COLOR.PURPLE[94],
  COLOR.INDIGO[94],
  COLOR.BLUE[94],
  COLOR.TURQUOISE[94],
  COLOR.EMERALD[100],
  COLOR.OLIVE[94],
  COLOR.GREEN[94],
  COLOR.MAGENTA[94],
  COLOR.RED[94],
] as const;

export const POD_SERIES_COLORS = [...FIGMA_POD_SERIES_COLOR_SEQUENCE] as const;
